import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { colors, Text } from 'main/ui'

const overflowStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const NameContainer = styled.div`
  ${overflowStyles};

  color: ${colors.text.default};
`

export const EmailContainer = styled.div`
  ${overflowStyles};

  color: ${colors.text.muted};
`

export const Email = styled(Text)`
  color: ${colors.text.muted};
  font-size: 13px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Pipe = styled(Text)`
  color: ${colors.text.muted};
`
